import React from 'react'
import HomeBanner from './home/HomeBanner'
import MissionVision from './home/MissionVision'
import HomeAbout from './home/HomeAbout'
import HomeReviews from './home/HomeReviews'
import HomeGallery from './home/HomeGallery'
import HomeBlog from './home/HomeBlog'
import HowDoes from './home/HowDoes'

const Home = () => {
  return (
    <>

      
      <HomeBanner />
      <HomeAbout />
      <MissionVision />
      <HowDoes />
      <HomeGallery />
      <HomeReviews />
      <HomeBlog />




    </>
  )
}

export default Home